export default "__VITE_ASSET__DQS3CFBm__"